import React from 'react';
import styled from 'styled-components';

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
`;

const ModalWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1050;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SimpleModal = ({ isOpen, onRequestClose, children }) => {
  if (!isOpen) return null;

  return (
    <>
      <ModalBackdrop onClick={onRequestClose} />
      <ModalWrapper>
        {children}
      </ModalWrapper>
    </>
  );
};

export default SimpleModal;